"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelImageVisibility = exports.CollectionModelImageVisibilityMutator = void 0;
var imageVisibility_state_1 = require("./imageVisibility.state");
var CollectionModelImageVisibilityMutator = /** @class */ (function () {
    function CollectionModelImageVisibilityMutator(imageVisibility) {
        this.imageVisibility = imageVisibility;
    }
    CollectionModelImageVisibilityMutator.prototype.setValue = function (state) {
        this.imageVisibility.collectionState.setFieldValue(this.imageVisibility.instanceId, state);
    };
    /** Gives a shallow clone of the image visibility state */
    CollectionModelImageVisibilityMutator.prototype.getValue = function () {
        return Object.assign({}, this.imageVisibility.state);
    };
    /**
     * Remove the state of this image visibility
     * *Warning:* You will need to unlink & clear the image visibility before destroying the state.
     * @see CollectionModelImageVisibilityStateMutator.remove
     */
    CollectionModelImageVisibilityMutator.prototype.destroyState = function () {
        this.imageVisibility.collectionState.setFieldValue(this.imageVisibility.instanceId, null);
    };
    /**
     * Remove the image visibility,
     * This will unlink and destroy the image visibility and all associated values.
     *
     * @see CollectionModelImageVisibilityStateMutator.remove
     */
    CollectionModelImageVisibilityMutator.prototype.remove = function () {
        this.imageVisibility.imageVisibilityState.Mutator.clear();
    };
    return CollectionModelImageVisibilityMutator;
}());
exports.CollectionModelImageVisibilityMutator = CollectionModelImageVisibilityMutator;
var CollectionModelImageVisibility = /** @class */ (function () {
    function CollectionModelImageVisibility(state, imageVisibilityId, captureId) {
        this.instanceId = imageVisibility_state_1.CollectionModelImageVisibilityState.imageVisibilityId(captureId);
        this.id = imageVisibilityId;
        this.captureId = captureId;
        this.imageVisibilityState = state;
    }
    Object.defineProperty(CollectionModelImageVisibility.prototype, "state", {
        get: function () {
            return this.collectionState.getFieldValue(this.instanceId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelImageVisibility.prototype, "collectionState", {
        get: function () {
            return this.imageVisibilityState.collection.state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelImageVisibility.prototype, "isDeletable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelImageVisibility;
}());
exports.CollectionModelImageVisibility = CollectionModelImageVisibility;
//# sourceMappingURL=imageVisibility.js.map